import type { IconGlyph } from '@ipfabric/ui-components/Icon/IconGlyph';
import type { RoutesTreeItem } from 'containers/App/Routes/RoutesTreeItem';
import type { ReactNode } from 'react';
import { ApplicationConnectivityReportTab } from './tabs/ApplicationConnectivityReportTab';
import { ApplicationDevicesTab } from './tabs/ApplicationDevicesTab';
import { ApplicationOverviewTab } from './tabs/ApplicationOverviewTab';

export const APPLICATION_ID_PARAM = 'applicationId';

export const APPLICATION_DETAIL_PATH = `/inventory/applications/:${APPLICATION_ID_PARAM}`;

export const applicationDetailTabDefs: {
  segment: string;
  title: string;
  icon: IconGlyph;
  element: ReactNode;
  default?: boolean;
}[] = [
  {
    segment: 'overview',
    title: 'Application overview',
    icon: 'fa-chart-network',
    element: <ApplicationOverviewTab />,
    default: true,
  },
  {
    segment: 'devices',
    title: 'Devices',
    icon: 'fa-server',
    element: <ApplicationDevicesTab />,
  },
  {
    segment: 'connectivity-report',
    title: 'Connectivity report',
    icon: 'fa-signal-stream',
    element: <ApplicationConnectivityReportTab />,
  },
];

export const applicationDetailChildRoutes: RoutesTreeItem[] =
  applicationDetailTabDefs.map((tab) => ({
    path: `${APPLICATION_DETAIL_PATH}/${tab.segment}`,
    element: tab.element,
  }));
